import _styled from "@emotion/styled/base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import { m } from 'framer-motion';
export var Panel = /*#__PURE__*/_styled(m.div, true ? {
  target: "emvqar30"
} : {
  target: "emvqar30",
  label: "Panel"
})(true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : {
  name: "1d3w5wq",
  styles: "width:100%",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi93b3JrZGlyL2xpYnMvbWF0Y2hhL3JlY2lwZXMvVGFicy9QYW5lbC9QYW5lbC52aWV3cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHa0MiLCJmaWxlIjoiL3dvcmtkaXIvbGlicy9tYXRjaGEvcmVjaXBlcy9UYWJzL1BhbmVsL1BhbmVsLnZpZXdzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBtIH0gZnJvbSAnZnJhbWVyLW1vdGlvbidcblxuZXhwb3J0IGNvbnN0IFBhbmVsID0gc3R5bGVkKG0uZGl2KWBcbiAgd2lkdGg6IDEwMCU7XG5gXG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});